import { render } from "./ArrowCollapseVertical.vue?vue&type=template&id=449d64a0"
import script from "./ArrowCollapseVertical.vue?vue&type=script&lang=js"
export * from "./ArrowCollapseVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArrowCollapseVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "449d64a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('449d64a0', __exports__)) {
    api.reload('449d64a0', __exports__)
  }
  
  module.hot.accept("./ArrowCollapseVertical.vue?vue&type=template&id=449d64a0", () => {
    api.rerender('449d64a0', render)
  })

}


export default __exports__